//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import {
  ILike2BuyV2MediaItem,
  Like2BuyV2ModerationItemFilter,
  NormalizedLike2BuyV2Items,
} from '@apis/like2buy-v2/like2BuyV2ModerationModel';
import { ILike2BuyV2Store } from '@apis/like2buy-v2/like2BuyV2StoreModel';
import { hasPermissionForTask } from '@services/permissions';

export interface ITikTokLike2BuyState {
  store: ILike2BuyV2Store | undefined;
  currentItemFilter: Like2BuyV2ModerationItemFilter;
  items: NormalizedLike2BuyV2Items;
  pinnedItems: ILike2BuyV2MediaItem[];
  totalCount: number;
  previewUrl: string | undefined;
  flags: {
    hasFetchedAllItems: boolean;
    hasFetchedInitialItems: boolean;
    hasFetchedPinnedItems: boolean;
    isAddingItems: boolean;
    isArchivingItems: boolean;
    isArchivingPinnedItems: boolean;
    isFetchingInitialItems: boolean;
    isFetchingStore: boolean;
    isFetchingPreviewUrl: boolean;
    isFetchingNextItems: boolean;
    isFetchingPinnedItems: boolean;
    isMaterializingItems: boolean;
    isPinningItems: boolean;
    isReorderingPinnedItems: boolean;
    isUnarchivingItems: boolean;
    isUnpinningItems: boolean;
  };
  errors: {
    addItemsError: string | undefined;
    archiveItemsError: string | undefined;
    fetchInitialItemsError: string | undefined;
    fetchStoreError: string | undefined;
    fetchPreviewUrlError: string | undefined;
    fetchNextItemsError: string | undefined;
    fetchPinnedItemsError: string | undefined;
    materializeError: string | undefined;
    pinItemsError: string | undefined;
    reorderPinnedItemsError: string | undefined;
    unpinItemsError: string | undefined;
    unarchiveItemsError: string | undefined;
  };
}

export interface ITikTokLike2BuyItemsSearchResult {
  mediaItems: NormalizedLike2BuyV2Items;
  totalCount: number;
}

// We use the same permission as Like2Buy v1
export const TIKTOK_L2B_MODERATE_TASK = 'like2buy:moderate';
export const hasTikTokLike2BuyModerationPermission = () =>
  hasPermissionForTask(TIKTOK_L2B_MODERATE_TASK);
